<template>
  <section id="authentication" class="container pt-2">
    <div class="blob blob-top-right bg-purple"></div>
    <div class="blob blob-bottom-left bg-yellow"></div>
    <h1 class="big-title mb-0">Rejoindre CodeSnippet</h1>
    <p class="w-4/6 mb-10">
      Pour utiliser l’application, vous devez créer un compte et vous y
      connecter. Vous pourrez par la suite créer des projets et rejoindre ceux
      d’autres utilisateurs.
    </p>
    <div class="p-grid">
      <div class="p-col-12 p-order-1 p-order-lg-0 p-lg-6">
        <Register />
      </div>
      <div class="p-col-12 p-order-0 p-order-lg-1 p-lg-6">
        <Login />
        <Message severity="info" :closable="false">
          <p class="text-2xl font-bold mb-1">
            J'ai reçu une invitation
          </p>
          <p>
            Si vous avez reçu une invitation pour rejoindre un projet, il vous
            suffit de vous inscrire avec l’adresse mail à laquelle vous avez
            reçu l’invitation pour y accéder.
          </p>
        </Message>
      </div>
    </div>
  </section>
</template>

<script>
import Register from "../components/Auth/Register.vue";
import Login from "../components/Auth/Login.vue";

export default {
  components: {
    Register,
    Login,
  },
};
</script>
